<script lang="ts" setup>
import { PriceType } from '@/views/search/types.ts';
import { useI18n } from 'vue-i18n';
import { rentPriceRangeMax, rentPriceRangeMin, salePriceRangeMax, salePriceRangeMin, useSearchFiltersStore } from '@/views/search/searchFiltersStore.ts';

const { t } = useI18n();

const filters = useSearchFiltersStore();

const toggleOption = (option: PriceType) => {
  if (filters.priceType === option) {
    filters.clearPriceType();
  } else {
    filters.priceType = option;
    filters.priceMin = option == PriceType.ForRent ? rentPriceRangeMin : salePriceRangeMin;
    filters.priceMax = option == PriceType.ForRent ? rentPriceRangeMax : salePriceRangeMax;
  }
};
</script>

<template>
  <div class="flex divide-x divide-gray-200 text-base/8 font-medium text-gray-700">
    <!-- For Sale Option -->
    <div>
      <label
        :class="[
          'focus-within:outline-ph-green-600 relative block cursor-pointer rounded-l-md px-3.5 py-1.5 text-gray-700 focus-within:z-10 focus-within:outline-2 focus-within:outline-offset-3',
          filters.priceType === PriceType.ForSale ? 'bg-ph-green-700 text-white' : 'bg-gray-100',
        ]"
      >
        <input :checked="filters.priceType === PriceType.ForSale" class="sr-only" type="checkbox" @change="toggleOption(PriceType.ForSale)" />
        <span>{{ t('views.search.for-sale') }}</span>
      </label>
    </div>
    <!-- For Rent Option -->
    <div>
      <label
        :class="[
          'focus-within:outline-ph-green-600 relative block cursor-pointer rounded-r-md px-3.5 py-1.5 text-gray-700 focus-within:z-10 focus-within:outline-2 focus-within:outline-offset-3',
          filters.priceType === PriceType.ForRent ? 'bg-ph-green-700 text-white' : 'bg-gray-100',
        ]"
      >
        <input :checked="filters.priceType === PriceType.ForRent" class="sr-only" type="checkbox" @change="toggleOption(PriceType.ForRent)" />
        <span>{{ t('views.search.for-rent') }}</span>
      </label>
    </div>
  </div>
</template>

<style lang="css" scoped></style>
